'use client';

import { createContext, useContext, type PropsWithChildren } from 'react';

type ToasterContextValue = {
  toasterId: string;
};

const ToasterContext = createContext<ToasterContextValue>({ toasterId: 'global' });

export function ToasterProvider({ children, toasterId }: PropsWithChildren<{ toasterId: string }>) {
  return <ToasterContext.Provider value={{ toasterId }}>{children}</ToasterContext.Provider>;
}

export function useToasterId() {
  const context = useContext(ToasterContext);
  return context.toasterId;
}
